"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    ListingCardWrapper: ()=>ListingCardWrapper,
    Img: ()=>Img,
    PriceCurrency: ()=>PriceCurrency,
    TextStrikeThrough: ()=>TextStrikeThrough,
    PriceCurrencyStrikeThrough: ()=>PriceCurrencyStrikeThrough
});
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
const external_styled_components_namespaceObject = require("styled-components");
var external_styled_components_default = /*#__PURE__*/ __webpack_require__.n(external_styled_components_namespaceObject);
const ListingCardWrapper = /*#__PURE__*/ external_styled_components_default()(external_pcln_design_system_namespaceObject.Box).withConfig({
    displayName: "HotlListingCard.styles__ListingCardWrapper"
})([
    "background-color:#fff;cursor:pointer;"
]);
const Img = /*#__PURE__*/ external_styled_components_default().img.withConfig({
    displayName: "HotlListingCard.styles__Img"
})([
    "object-fit:cover;height:153px;width:100%;border-top-left-radius:16px;border-top-right-radius:16px;"
]);
const PriceCurrency = /*#__PURE__*/ external_styled_components_default()(external_pcln_design_system_namespaceObject.Text.span).withConfig({
    displayName: "HotlListingCard.styles__PriceCurrency"
})([
    "vertical-align:super;position:relative;top:-2px;margin-right:2px;"
]);
const PriceCurrencyStrikeThrough = /*#__PURE__*/ external_styled_components_default()(PriceCurrency).withConfig({
    displayName: "HotlListingCard.styles__PriceCurrencyStrikeThrough"
})([
    "top:1px;"
]);
const TextStrikeThrough = /*#__PURE__*/ external_styled_components_default()(external_pcln_design_system_namespaceObject.Text).withConfig({
    displayName: "HotlListingCard.styles__TextStrikeThrough"
})([
    "& ::before{content:'';width:40%;position:absolute;right:0px;top:14px;border-bottom:2px solid rgb(79,111,143);transform:skewY(-13deg);}"
]);
exports.Img = __webpack_exports__.Img;
exports.ListingCardWrapper = __webpack_exports__.ListingCardWrapper;
exports.PriceCurrency = __webpack_exports__.PriceCurrency;
exports.PriceCurrencyStrikeThrough = __webpack_exports__.PriceCurrencyStrikeThrough;
exports.TextStrikeThrough = __webpack_exports__.TextStrikeThrough;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "Img",
    "ListingCardWrapper",
    "PriceCurrency",
    "PriceCurrencyStrikeThrough",
    "TextStrikeThrough"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
